import {
  lifeTimeText,
  selectedText,
} from '@/pages/opinion/components/BubbleCommon';
import { getGameStoreStatsInfo } from '@/pages/opinion/services';
import { DBO_TM } from '@op/utils/format';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';

export default function useGetGameStoreStatsInfo({
  gameInfo,
  filter,
  type,
  needLink = false,
  lifetimeTitle = 'Lifetime Accum. Rating',
  selectedTitle = 'Selected AVG. Rating',
}: any) {
  const [ratingInfo, setRatingInfo] = useState<{ [key: string]: any }>({});
  const [oldRatingInfo, setOldRatingInfo] = useState<{ [key: string]: any }>(
    {},
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!gameInfo || !filter) return;

    setLoading(true);

    getGameStoreStatsInfo({
      ...filter,
      ...gameInfo,
      channel: [type], // "app store"、 "google play"、"taptap" 对应不同tab
      channel_type: 'comments',
      types: ['lifetime', 'selected'],
      need_link: needLink,
      need_region: false,
      is_today: DBO_TM.isToday(filter), // 前端判断是否是今天
    }).then((data: any) => {
      const info: { [key: string]: any } = {};
      const oldInfo: { [key: string]: any } = {};
      data?.forEach((item: any) => {
        const {
          type: dataType,
          new_list,
          old_list,
          link_of_start_time,
          link_of_end_time,
        } = item || {};
        info[dataType] = {
          ...(new_list?.find((item: any) => item.channel === type) || {}),
          time: [filter?.start_time, filter?.end_time],
        };

        oldInfo[dataType] = {
          ...(old_list?.find((item: any) => item.channel === type) || {}),
          time: [link_of_start_time, link_of_end_time],
        };
      });
      setRatingInfo(info);
      setOldRatingInfo(oldInfo);
      setLoading(false);
    });
  }, [filter, type]);

  const { formatMessage } = useIntl();
  const ratings = useMemo(() => {
    if (!filter) return [];
    const { start_time, end_time } = filter;
    const st = moment(start_time).format('yyyy-MM-DD');
    const et = moment(end_time).format('yyyy-MM-DD');
    return [
      {
        id: 1,
        ratingKey: 'lifetime',
        title: formatMessage({ id: lifetimeTitle }),
        time: end_time,
        context: lifeTimeText,
      },
      {
        id: 2,
        ratingKey: 'selected',
        title: formatMessage({ id: selectedTitle }),
        time: st === et ? et : `${st} to ${et}`,
        context: selectedText,
      },
    ];
  }, [formatMessage, filter]);

  return {
    ratingInfo,
    oldRatingInfo,
    loading,
    ratings,
  };
}
